module.exports = __webpack_public_path__ + "media/images/organizations-3d778b82ea66ec5654c36286f50e1908.svg";